import bike from "../../../static/images/grid-list/bike.jpg";
import breakfast from "../../../static/images/grid-list/breakfast.jpg";
import burgers from "../../../static/images/grid-list/burgers.jpg";
import camera from "../../../static/images/grid-list/camera.jpg";
import hats from "../../../static/images/grid-list/hats.jpg";
import honey from "../../../static/images/grid-list/honey.jpg";
import morning from "../../../static/images/grid-list/morning.jpg";
import mushroom from "../../../static/images/grid-list/mushroom.jpg";
import olive from "../../../static/images/grid-list/olive.jpg";
import plant from "../../../static/images/grid-list/plant.jpg";
import star from "../../../static/images/grid-list/star.jpg";
import vegetables from "../../../static/images/grid-list/vegetables.jpg";

const tileData = [
  {
    img: breakfast,
    title: "breakfast",
    author: "author",
    cols: 2,
    featured: true,
  },
  {
    img: burgers,
    title: "burgers",
    author: "author",
    cols: 1,
    featured: false,
  },
  {
    img: camera,
    title: "camera",
    author: "author",
    cols: 1,
    featured: false,
  },
  {
    img: hats,
    title: "hats",
    author: "author",
    cols: 1,
    featured: false,
  },
  {
    img: honey,
    title: "honey",
    author: "author",
    cols: 1,
    featured: false,
  },
  {
    img: morning,
    title: "morning",
    author: "author",
    cols: 1,
    featured: false,
  },
  {
    img: mushroom,
    title: "mushroom",
    author: "author",
    cols: 1,
    featured: false,
  },
  {
    img: olive,
    title: "olive",
    author: "author",
    cols: 1,
    featured: false,
  },
  {
    img: plant,
    title: "plant",
    author: "author",
    cols: 1,
    featured: false,
  },
  {
    img: star,
    title: "star",
    author: "author",
    cols: 2,
    featured: true,
  },
  {
    img: vegetables,
    title: "vegetables",
    author: "author",
    cols: 2,
    featured: false,
  },
  {
    img: bike,
    title: "bike",
    author: "author",
    cols: 1,
    featured: false,
  },
];

export default tileData;
